module.exports = __webpack_public_path__ + "img/thumbnail_BlackWildebeest_f_normal.156fd09d.png";